import "./newCustomAds.scss";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import {
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  CircularProgress,
  Card,
  CardContent,
  Typography,
  Grid,
} from "@mui/material";
import { Upload } from "@mui/icons-material";

const NewCustomAds = () => {
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const navigate = useNavigate();

  const [users, setUsers] = useState([]);
  const [formData, setFormData] = useState({
    userId: "",
  });

  const [images, setImages] = useState([]);
  const [previews, setPreviews] = useState([]);
  const [loading, setLoading] = useState(false);

  // 🔥 Fetch Village/Club Users
  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const res = await axios.get(`${BASE_URL}/api/users/findAllAdminUser/1`);
        setUsers(res.data);
      } catch (err) {
        console.error("Error fetching users:", err);
      }
    };
    fetchUsers();
  }, [BASE_URL]);

  const handleChange = (e) => {
    setFormData({ ...formData, userId: e.target.value });
  };

  const handleFileChange = (e) => {
    const selectedFiles = Array.from(e.target.files);

    if (selectedFiles.length > 4) {
      alert("Maximum 4 images allowed");
      return;
    }

    setImages(selectedFiles);

    const previewUrls = selectedFiles.map((file) => URL.createObjectURL(file));
    setPreviews(previewUrls);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.userId) {
      alert("Please select village");
      return;
    }

    if (images.length === 0) {
      alert("Please upload images");
      return;
    }

    const data = new FormData();
    data.append("userId", formData.userId);
    images.forEach((file) => data.append("customAdsImages", file));

    try {
      setLoading(true);

      await axios.post(`${BASE_URL}/api/adsCustom/addCustomAds`, data, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      navigate("/customads");
    } catch (err) {
      alert(err.response?.data?.msg || "Error occurred");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="newUser">
      <Sidebar />
      <div className="newUserContainer">
        <Navbar />
        <Card sx={{ m: 3, p: 3 }}>
          <CardContent>
            <Typography variant="h5" gutterBottom>
              Add Custom Ads
            </Typography>

            <form onSubmit={handleSubmit}>
              <Grid container spacing={3}>
                {/* Village Select */}
                <Grid item xs={12} md={6}>
                  <FormControl fullWidth>
                    <InputLabel>Select Village / Club</InputLabel>
                    <Select value={formData.userId} onChange={handleChange}>
                      {users.map((user) => (
                        <MenuItem key={user._id} value={user._id}>
                          {user.villageName || user.clubName}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>

                {/* Upload */}
                <Grid item xs={12}>
                  <Button
                    variant="outlined"
                    component="label"
                    startIcon={<Upload />}
                  >
                    Upload Images (Max 4)
                    <input
                      type="file"
                      hidden
                      multiple
                      accept="image/*"
                      onChange={handleFileChange}
                    />
                  </Button>
                </Grid>

                {/* Preview */}
                <Grid item xs={12}>
                  <Grid container spacing={2}>
                    {previews.map((src, index) => (
                      <Grid item key={index}>
                        <img
                          src={src}
                          alt="preview"
                          style={{
                            width: 120,
                            height: 120,
                            objectFit: "cover",
                            borderRadius: 10,
                            boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
                          }}
                        />
                      </Grid>
                    ))}
                  </Grid>
                </Grid>

                {/* Submit */}
                <Grid item xs={12}>
                  <Button
                    type="submit"
                    variant="contained"
                    size="large"
                    disabled={loading}
                  >
                    {loading ? (
                      <CircularProgress size={24} color="inherit" />
                    ) : (
                      "Save Custom Ads"
                    )}
                  </Button>
                </Grid>
              </Grid>
            </form>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default NewCustomAds;
